import {IAnalyticEvent} from "services-comun-meteored/modules/services/cmp/web/analytic-event";
import {EAction, ELabel} from "../event-definition";
import {Event} from "../event";
import cmp, {site} from "../../context/context";
import {TCString} from "../../tcstring/t-c-string";
import {Session} from "../../session/session";
import {isDesktop, isMobile, isTablet} from "../../util/navigator";
import {TPlatform} from "services-comun-meteored/modules/services/cmp/backend/interface";
import eventQueue from "./event-queue";


export class AnalyticEvent {
    /* STATIC */
    private static ENABLED: Map<string, string[]> = new Map<string, string[]>(
        [
            [
                EAction.GDPR, [
                    ELabel.APARECE,
                    ELabel.SOCIOS,
                    ELabel.CONFIGURACION,
                    // ELabel.YA_ACEPTADO,
                    ELabel.ACEPTAR,
                    ELabel.RECHAZAR,
                    ELabel.APARECE_GLOBAL,
                    ELabel.ACEPTAR_GLOBAL,
                    ELabel.RECHAZAR_GLOBAL,
                    'valor_0',
                    'valor_1',
                    'valor_2',
                ]
            ],
            [
                EAction.CONFIGURAR, [
                    ELabel.CERRAR,
                    ELabel.RECHAZAR_TODO,
                    ELabel.ACEPTAR_TODO,
                    ELabel.ACEPTAR_TODO_GUARDAR,
                    ELabel.GUARDAR_CERRAR_DESHABILITADO,
                    ELabel.GUARDAR_CERRAR_HABILITADO,
                    ELabel.APARECE_GLOBAL,
                    ELabel.ACEPTAR_GLOBAL,
                    ELabel.RECHAZAR_GLOBAL,
                ]
            ],
            [
                EAction.INSIST, [
                    ELabel.CERRAR,
                    ELabel.INICIA_SESION,
                    ELabel.REGISTRARSE,
                    ELabel.ACEPTO_Y_CAMBIO,
                    ELabel.ACEPTAR_GLOBAL
                ]
            ]
        ]
    );


    public static build(event: Event): AnalyticEvent {

        return new AnalyticEvent({
            date: Date.now(),
            name: event.name,
            action: event.action,
            tag: event.label,
            cmp: {
                cmp_version: cmp().version(),
                gvl_version: cmp().vendorList?.version??0,
            },
            consent: {
                tc_date: (cmp().tcString as TCString).created.getTime(),
                tc_string: cmp().tcString?.toString()||'',
            },
            loader: {
                language: site.language,
                config: site.requestedConfig
            },
            session: {
                id: Session.get().key,
                platform: isMobile()
                    ? 'mobile'
                    : (
                        isTablet()
                            ? 'tablet'
                            : (
                                isDesktop()
                                    ? 'desktop'
                                    : 'other'
                            )
                    ),
                url: window?.location?.href,
            },
            platform: {
                name: site.domain,
                hash: site.hash,
                type: TPlatform.WEB,
                config: {
                    config: site.config
                }
            }
        });
    }

    /* INSTANCE */
    protected constructor(private readonly _data: IAnalyticEvent) {
    }

    protected get data(): IAnalyticEvent {
        return this._data;
    }

    public send(): void {
        if (AnalyticEvent.ENABLED.get(this.data.action)?.includes(this.data.tag)) {
            eventQueue.send(this.data)
        }
    }
}
